// components/clients/ClientRow.jsx

import { Link, useNavigate } from "react-router-dom";

import "./css/ClientsTable.css";

import kycButtonEdit from "../../images/kyc-button-edit.png";
import kycButtonShow from "../../images/kyc-button-show.png";

export default function ClientRow({ client, onEdit, onView, onDelete }) {
  const navigate = useNavigate();
  // ---------------------------
  // LINKS TO OTHER PAGES
  // ---------------------------

  const statusIconClass =
    client.status === "client"
      ? "bi bi-shield-check typeIcon typeIconClient"
      : // bi-check-circle, bi-shield-check, bi-award
      client.status === "prospect"
      ? "bi bi-binoculars typeIcon typeIconProspect"
      : // bi-bullseye
      client.status === "former"
      ? "bi bi-archive typeIcon typeIconFormerClient"
      : "bi bi-question-circle typeIcon";

  function flowMeta(stage) {
    switch (stage) {
      case "sent":
        return {
          label: "Sent",
          icon: "bi-hourglass-top",
          // icon: "bi-send-check",
          cls: "badgeKycFlow badgeKycFlowSent",
        };
      case "to_review":
        return {
          label: "To review",
          icon: "bi-exclamation-triangle",
          // icon: "bi-mailbox-flag",
          // icon: "bi-exclamation-triangle",
          // icon: "bi-file-earmark-arrow-down",
          cls: "badgeKycFlow badgeKycFlowToReview",
        };
      case "approved":
        return {
          label: "Approved",
          icon: "bi-check-circle",
          cls: "badgeKycFlow badgeKycFlowApproved",
        };
      default:
        return null; // not_sent hidden
    }
  }
  // function flowMeta(stage) {
  //   switch (stage) {
  //     // case "not_sent":
  //     //   return { label: "Not sent", cls: "badgeKycFlow badgeKycFlowNotSent" };
  //     case "sent":
  //       return { label: "Sent", cls: "badgeKycFlow badgeKycFlowSent" };
  //     case "to_review":
  //       return { label: "To review", cls: "badgeKycFlow badgeKycFlowToReview" };
  //     case "approved":
  //       return { label: "Approved", cls: "badgeKycFlow badgeKycFlowApproved" };
  //     default:
  //       return null;
  //     // return { label: "—", cls: "badgeKycFlow badgeKycFlowUnknown" };
  //   }
  // }
  const flow = flowMeta(client.kycFlowStage);
  return (
    // <tr>
    <tr
      role="button"
      tabIndex={0}
      onClick={() => navigate(`/kyc/${client.id}`)}
      onKeyDown={(e) => {
        if (e.target !== e.currentTarget) return;
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          navigate(`/kyc/${client.id}`);
        }
      }}
      className="clientRowClickable"
    >
      <td className="ps-3 clientsName">{client.clientName}</td>
      {/* <td>
        {client.clientType === "individual" ? (
          <span className="badge badgeType badgeTypeIndividual">
            Individual
          </span>
        ) : client.clientType === "entity" ? (
          <span className="badge badgeType badgeTypeEntity">Entity</span>
        ) : (
          <span className="badge badgeType badgeTypeUnknown">
            {client.clientType || "—"}
          </span>
        )}
      </td> */}
      <td>
        {client.clientType === "individual" ? (
          <span className="badge badgeType badgeTypeIndividual">
            <i
              className="bi bi-person me-1 typeIcon typeIconIndividual"
              aria-hidden="true"
            />
            Individual
          </span>
        ) : client.clientType === "entity" ? (
          <span className="badge badgeType badgeTypeEntity">
            <i
              className="bi bi-building me-1 typeIcon typeIconEntity"
              aria-hidden="true"
            />
            Entity
          </span>
        ) : (
          <span className="badge badgeType badgeTypeUnknown">
            {client.clientType || "—"}
          </span>
        )}
      </td>
      <td>
        {/* <span className="badge badgeStatus">{client.status}</span> */}
        <span className="badge badgeStatus">
          <i className={`statusIcon ${statusIconClass}`} aria-hidden="true" />
          <span className="ms-1">{client.status}</span>
        </span>
      </td>

      <td>
        <div className="d-flex flex-wrap gap-2">
          {client.kycCompleted ? (
            <Link
              to={`/kyc/${client.id}`}
              className={`badge badgeKyc badgeKycComplete`}
              onClick={(e) => e.stopPropagation()} // IMPORTANT: don't trigger row click
              title="Open KYC for edit"
            >
              <i className="bi bi-check-circle me-1" aria-hidden="true" />
              Complete
            </Link>
          ) : (
            // <span className="badge badgeKyc badgeKycComplete">
            //   <i className="bi bi-check-circle me-1" aria-hidden="true" />
            //   Complete
            // </span>
            <Link
              to={`/kyc/${client.id}`}
              className={`badge badgeKyc badgeKycUncomplete`}
              onClick={(e) => e.stopPropagation()} // IMPORTANT: don't trigger row click
              title="Open KYC for edit"
            >
              <i className="bi bi-patch-question me-1" aria-hidden="true" />
              Incomplete
            </Link>
            // <span className="badge badgeKyc badgeKycUncomplete">
            //   <i className="bi bi-patch-question me-1" aria-hidden="true" />
            //   Incomplete
            // </span>
          )}
          {/* bi-bookmark-x bi-person-raised-hand bi-hand-index-thumb */}
          {/* {client.kycCompleted ? (
            <span className="badge badgeKyc badgeKycComplete">Complete</span>
          ) : (
            <span className="badge badgeKyc badgeKycUncomplete">
              Incomplete
            </span>
          )} */}
        </div>
      </td>
      <td>
        <div className="d-flex flex-wrap gap-2">
          {(() => {
            const flow = flowMeta(client.kycFlowStage);
            if (!flow) return null;

            // if it's "to_review", make it clickable to open review page
            if (
              client.kycFlowStage === "to_review" &&
              client.kycLastSubmissionId
            ) {
              return (
                <Link
                  to={`/kyc-review/${client.kycLastSubmissionId}`}
                  state={{ from: "clients" }}
                  className={`badge badgeKycFlow ${flow.cls}`}
                  onClick={(e) => e.stopPropagation()} // IMPORTANT: don't trigger row click
                  title="Open submitted KYC for review"
                >
                  <i className={`bi ${flow.icon} me-1`} aria-hidden="true" />
                  {flow.label}
                </Link>
              );
            }

            // ✅ SENT => open inbox
            if (client.kycFlowStage === "sent") {
              return (
                <Link
                  to={`/kyc-inbox`}
                  className={`badge badgeKycFlow ${flow.cls}`}
                  onClick={(e) => e.stopPropagation()}
                  title="Open KYC Inbox"
                >
                  <i className={`bi ${flow.icon} me-1`} aria-hidden="true" />
                  {flow.label}
                </Link>
              );
            }

            // sent/approved are just visible (not clickable)
            return (
              <span className={`badge badgeKycFlow ${flow.cls}`}>
                <i className={`bi ${flow.icon} me-1`} aria-hidden="true" />
                {flow.label}
              </span>
            );
          })()}
          {/* ✅ show only if sent / to_review / approved */}
          {/* {flow && (
            <span className={`badge badgeKycFlow ${flow.cls}`}>
              <i className={`bi ${flow.icon} me-1`} aria-hidden="true" />
              {flow.label}
            </span>
          )} */}
          {/* {flow && (
            <span className={`badge badgeKycFlow ${flow.cls}`}>
              {flow.label}
            </span>
          )} */}
        </div>
      </td>
      {/* <td>
        {client.kycCompleted ? (
          <span className="badge badgeKyc badgeKycComplete">Complete</span>
        ) : (
          <span className="badge badgeKyc badgeKycUncomplete">Uncomplete</span>
        )}
      </td> */}
      <td className="clientsDate">{client.lastKycLabel}</td>
      <td
        className="text-end clientsActionsCol"
        // style={{ border: "1px solid red" }}
      >
        <Link
          className="kyc-image-link"
          // className="btn btn-sm clientsBtn clientsBtnKyc me-2"
          to={`/kyc-view/${client.id}`}
          onClick={(e) => e.stopPropagation()}
        >
          <img
            src={kycButtonShow}
            alt="KYC"
            className="kyc-image-btn kyc-show-btn"
          />
        </Link>

        <Link
          className="kyc-image-link"
          // className="btn btn-sm clientsBtn clientsBtnKyc me-2"
          to={`/kyc/${client.id}`}
          onClick={(e) => e.stopPropagation()}
          style={{ marginLeft: 15 }}
          // style={{ border: "1px solid green" }}
        >
          <img
            src={kycButtonEdit}
            alt="KYC"
            className="kyc-image-btn kyc-edit-btn"
          />
        </Link>
      </td>
      <td className="text-end clientsActionsCol">
        {/* <button
          className="btn btn-sm clientsBtn clientsBtnView me-2"
          onClick={onView}
        >
          View
        </button> */}

        <button
          type="button"
          className="btn btn-sm clientsBtn clientsBtnDeleteIcon"
          // onClick={onDelete}
          // onClick={() => onDelete(client)}
          onClick={(e) => {
            e.stopPropagation();
            onView?.();
          }}
          aria-label="View"
          title="View"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            className="bi bi-eye"
            viewBox="0 0 16 16"
          >
            <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z" />
            <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0" />
          </svg>
        </button>

        {/* <button
          className="btn btn-sm clientsBtn clientsBtnEdit me-2"
          onClick={(e) => {
            e.stopPropagation(); // Prevent action buttons from also triggering the row click
            onEdit?.();
          }}
        >
          Edit
        </button> */}

        {/* <button
          className="btn btn-sm clientsBtn clientsBtnDelete"
          onClick={onDelete}
        >
          Delete
        </button> */}

        <button
          type="button"
          className="btn btn-sm clientsBtn clientsBtnDeleteIcon"
          onClick={(e) => {
            e.stopPropagation();
            onEdit?.();
          }}
          aria-label="Edit"
          title="Edit"
        >
          {/* <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            class="bi bi-pen-fill"
            viewBox="0 0 16 16"
          >
            <path d="m13.498.795.149-.149a1.207 1.207 0 1 1 1.707 1.708l-.149.148a1.5 1.5 0 0 1-.059 2.059L4.854 14.854a.5.5 0 0 1-.233.131l-4 1a.5.5 0 0 1-.606-.606l1-4a.5.5 0 0 1 .131-.232l9.642-9.642a.5.5 0 0 0-.642.056L6.854 4.854a.5.5 0 1 1-.708-.708L9.44.854A1.5 1.5 0 0 1 11.5.796a1.5 1.5 0 0 1 1.998-.001" />
          </svg> */}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            className="bi bi-pen"
            viewBox="0 0 16 16"
          >
            <path d="m13.498.795.149-.149a1.207 1.207 0 1 1 1.707 1.708l-.149.148a1.5 1.5 0 0 1-.059 2.059L4.854 14.854a.5.5 0 0 1-.233.131l-4 1a.5.5 0 0 1-.606-.606l1-4a.5.5 0 0 1 .131-.232l9.642-9.642a.5.5 0 0 0-.642.056L6.854 4.854a.5.5 0 1 1-.708-.708L9.44.854A1.5 1.5 0 0 1 11.5.796a1.5 1.5 0 0 1 1.998-.001m-.644.766a.5.5 0 0 0-.707 0L1.95 11.756l-.764 3.057 3.057-.764L14.44 3.854a.5.5 0 0 0 0-.708z" />
          </svg>

          {/* <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            class="bi bi-pencil-square"
            viewBox="0 0 16 16"
          >
            <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
            <path
              fill-rule="evenodd"
              d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z"
            />
          </svg> */}
        </button>

        <button
          type="button"
          className="btn btn-sm clientsBtn clientsBtnDeleteIcon"
          // onClick={onDelete}
          // onClick={() => onDelete(client)}
          onClick={(e) => {
            e.stopPropagation();
            onDelete?.();
          }}
          aria-label="Delete"
          title="Delete"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="bi bi-trash2-fill clientsIcon"
            viewBox="0 0 16 16"
            aria-hidden="true"
            fill="currentColor"
          >
            <path d="M2.037 3.225A.7.7 0 0 1 2 3c0-1.105 2.686-2 6-2s6 .895 6 2a.7.7 0 0 1-.037.225l-1.684 10.104A2 2 0 0 1 10.305 15H5.694a2 2 0 0 1-1.973-1.671zm9.89-.69C10.966 2.214 9.578 2 8 2c-1.58 0-2.968.215-3.926.534-.477.16-.795.327-.975.466.18.14.498.307.975.466C5.032 3.786 6.42 4 8 4s2.967-.215 3.926-.534c.477-.16.795-.327.975-.466-.18-.14-.498-.307-.975-.466z" />
          </svg>
        </button>
      </td>
    </tr>
  );
}
